<template>
  <div class="footer">
    <div class="footerContent">
      <div class="f-top">
        <div>
          <p class="f12">主办单位</p>
          <p>天津滨海高新技术产业开发区政务服务办公室</p>
        </div>
        <div>
          <p class="f12">平台名称</p>
          <p>天津滨海高新区政策兑现服务平台</p>
        </div>
        <div>
          <p class="f12">咨询电话</p>
          <p>022-83712738 / 022-65611009</p>
        </div>
      </div>
      <div class="f-bottom f12">建议使用 1920 * 1080 分辨率 IE8.0以上版本浏览器</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {
  height: 176px;
  background-color: #696969;
  width: 100%;
  min-width: 1200px;
  color: #fff;
  
  .footerContent {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .f12 {
      font-size: 12px;
    }
    .f-top {
      width: 100%;
      padding-bottom: 25px;
      border-bottom: 1px solid #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .f-bottom {
      margin-top: 12px;
    }
  }
}
</style>